<template>
  <img
    :src="'https://y3wm.cn' + config.value"
    :style="{ width: config.width + '%' }"
    @click="auth"
    alt
  />
</template>

<script>
export default {
  props: {
    config: {
      type: Object,
      default () {
        return {}
      }
    },
    appletId: {
      type: String | Number,
      default: ''
    }
  },
  data () {
    return {
      webpath: "/prod-api/common/wx/signature"
    }
  },
  created () {
    setTimeout(() => {
      this.initTocken();
    }, 1000);
    console.log(this.$route.query._u)
  },
  methods: {
    auth () {
      console.log("auth", this.config)
      this.$router.push({ path: "/identify", query: { model: this.config.model, appletId: this.appletId, url: this.$route.query.url } })
      // wx.ready(function () {
      //   console.log('wxsuccess');
      //   wx.scanQRCode({
      //     needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
      //     scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
      //     success: function (res) {
      //       // alert(JSON.stringify(res))
      //       console.log(res);
      //       let result = res.resultStr;// + '?_u=' + location.href; // 当needResult 为 1 时，扫码返回的结果
      //       // console.log(result);
      //       window.location.href = result
      //       // console.log(result);
      //       // var code = result.substring(result.lastIndexOf("/") + 1);
      //       // console.log(code);
      //       // this.$router.push({ path: '/result', query: { id: code } });
      //     }
      //   });
      // });
      // wx.error(function (res) {
      //   console.error(res)
      // });
    },
    initTocken: function () {
      var that = this;
      console.log(that.$route.query._u)
      $.ajax({
        type: "get",
        url: that.webpath,
        async: false,
        cache: false,
        timeout: 60000,
        scriptCharset: "utf-8",
        // data: { url: location.href.split('?')[0] },
        data: { url: that.$route.query._u || location.href.split('?')[0] },
        success: function (sign) {
          // console.log('xxxxx', sign)
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: sign.appid, // 必填，公众号的唯一标识
            timestamp: sign.timestamp, // 必填，生成签名的时间戳
            nonceStr: sign.noncestr, // 必填，生成签名的随机串
            signature: sign.signature,// 必填，签名，见附录1
            jsApiList: ['getLocation', 'chooseImage', 'uploadImage', 'previewImage', 'downloadImage', 'scanQRCode'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
        },
        error: function (err) {
          console.log(err)
        }
      });

    }
  }
}
</script>

<style lang="scss" scoped>
.judgetrue {
  box-sizing: border-box;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/scanQR/index.vue